// extracted by css-extract-rspack-plugin
export default {"wrapper":"_602590e1","horizontal":"_cbe8254c","vertical":"_7c31dfe0"};